import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { RenderingProps } from 'src/shared/shared.types';

export type C44TestimonialCardFields = {
  TestimonialText?: RichTextField;
  TestimonialAuthor?: Field<string>;
  TestimonialAuthorTitle?: Field<string>;
};

export type C44TestimonialCardProps = RenderingProps<C44TestimonialCardFields>;
